import styled from "styled-components"
import ResultsCard from "./ResultsCard"
import StatsCard from "./StatsCard"
import { useLeague } from "../../../context/useLeague"
import { FC, useEffect, useState } from "react"
import Dropdown from "../../common/Dropdown"
import { TopPerformer } from "../../../models/leagueStats"
import placeholderImage from "../../../images/common/vgc-logo.png"

const Stats: FC = () => {
  const { leagueStats, matchResults } = useLeague()
  const [topPerformers, setTopPerformers] = useState<TopPerformer[]>([])
  const [selectedStat, setSelectedStat] = useState("goals")

  const playerSearchOptions = [
    {label: "Top Goals", value: "goals"},
    {label: "Top Assists", value: "assists"},
    {label: "Top Saves", value: "saves"},
    { label: "Top Tackles", value: "tackles" },
    { label: "Top Passes", value: "passes" },
    { label: "Top Headers", value: "headers" },
    { label: "Top Ints", value: "interceptions" },
    { label: "Top Sheets", value: "cleanSheets" },
  ]

  useEffect(() => {
    if (!leagueStats) {
      return;
    }
    const key = selectedStat as keyof typeof leagueStats.topPerformers;
    setTopPerformers(leagueStats.topPerformers[key]);
  }, [selectedStat, leagueStats?.topPerformers]);

  const handleSelectStat = (option: any) => {
    setSelectedStat(option.value);
  }

  return (
    <Container>
      <FixturesContainer>
        <p className="p-0 m-0 mb-1 ps-sm-3 fw-bold">Match Results</p>
        <div className="container d-flex h-100 flex-column justify-content-around ">
          {matchResults.map((result) => (
            <div className="row px-3 px-sm-0">
              <ResultsCard
                badge1={result?.homeImage || placeholderImage}
                score1={result?.homeScore}
                badge2={result?.awayImage || placeholderImage}
                score2={result?.awayScore}
              />
            </div>
          ))}
        </div>
      </FixturesContainer>
      <StatsContainer>
        <div className="d-flex justify-content-between align-items-end">
          <p className="p-0 m-0 mb-1 ps-sm-3 fw-bold">Top Performers</p>
          <span className="mb-1 mx-sm-3 mt-lg-1">
            <Dropdown
              options={playerSearchOptions}
              onSelect={handleSelectStat}
              text="Select Stat"
            />
          </span>
        </div>
        <div className="container d-flex h-100 flex-column justify-content-around">
          {topPerformers ? (
            <>
            {topPerformers.length > 0 ? 
              <div className="row px-3 px-sm-0 ">
                <StatsCard
                  total={topPerformers[0].total}
                  player={topPerformers[0].playerName}
                  title={
                      `Top ${selectedStat}`
                  }
                />
             </div>
            : null}
            {topPerformers.length > 1 ? 
              <div className="row px-3 px-sm-0">
                <StatsCard
                  total={topPerformers[1].total}
                  player={topPerformers[1].playerName}
                  title={
                    selectedStat === "General" ? "Top Assister" : `2nd place`
                  }
                />
              </div>
            : null}
            {topPerformers.length > 2 ? 
              <div className="row px-3 px-sm-0">
                <StatsCard
                  total={topPerformers[2].total}
                  player={topPerformers[2].playerName}
                  title={
                    selectedStat === "General" ? "Top Tackler" : `3rd place`
                  }
                />
              </div>
            : null}
            {topPerformers.length > 3 ? 
              <div className="row px-3 px-sm-0">
                <StatsCard
                  total={topPerformers[3].total}
                  player={topPerformers[3].playerName}
                  title={
                    selectedStat === "General" ? "Top Passer" : `4th place`
                  }
                />
              </div>
            : null}
            {topPerformers.length > 4 ? 
              <div className="row px-3 px-sm-0">
                <StatsCard
                  total={topPerformers[4].total}
                  player={topPerformers[4].playerName}
                  title={
                    selectedStat === "General" ? "Most Saves" : `5th place`
                  }
                />
                </div>
            : null}
            </>
          ) : null}
        </div>
      </StatsContainer>
    </Container>
  )
}

export default Stats

const Container = styled.div`
  width: 100%;
  @media (max-width: 992px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 768px) {
    flex-direction: column;
  }
  @media (max-width: 576px) {
    display: block;
    padding: 0 1rem;
  }
  margin-bottom: 1rem;
`
const FixturesContainer = styled.div`
  @media (max-width: 992px) {
    width: 50%;
    margin-top: 1rem;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
  width: 100%;
`
const StatsContainer = styled.div`
  height: 50%;
  @media (max-width: 992px) {
    width: 50%;
    margin-top: 1rem;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    margin-top: 2rem;
  }
`
